<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.antecedentes_odontologicos.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_antecedente.codigo"
                            :validator="item"
                            v-model="item.$model.antecedente_usuario.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtons';
import antecedentesOdontologicosService from '../../../../services/antecedentesOdontologicosService';
import antecedentesOdontologicosUsuarioService from '../../../../services/antecedentesOdontologicosUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            antecedentes_odontologicos: []
        }
    },
    validations(){
        return {
            antecedentes_odontologicos:{
                $each:{
                    antecedente_usuario:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let antecedentes_usuario = [];

                this.antecedentes_odontologicos.forEach((x) => {
                    if (x.antecedente_usuario.valor !== "") {
                        antecedentes_usuario.push({ ...x.antecedente_usuario });
                    }
                });

                this.LoaderSpinnerShow();
                await antecedentesOdontologicosUsuarioService.store({
                    antecedentes_usuario: antecedentes_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await antecedentesOdontologicosService.index({
            params: filter
        });

        const antecedentes_usuario = await antecedentesOdontologicosUsuarioService.index(
            this.usuario.id
        );

        this.antecedentes_odontologicos = response.data.map((y) => {
            const indice = antecedentes_usuario.data.findIndex(
                (a) => a.id_antecedente === y.id
            );
            y.antecedente_usuario = {
                id: indice !== -1 ? antecedentes_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_antecedente: y.id,
                valor: indice !== -1 ? antecedentes_usuario.data[indice].valor : "",
            };
            return y;
        });
    }

}
</script>